import React from 'react';

const ContactPage = () => {
  return (
    <div>
      <h1>Contacto</h1>
      <form>
        <label>
          Nombre:
          <input type="text" name="name" />
        </label>
        <label>
          Email:
          <input type="email" name="email" />
        </label>
        <label>
          Mensaje:
          <textarea name="message" />
        </label>
        <button type="submit">Enviar</button>
      </form>
    </div>
  );
};

export default ContactPage;
